@for (note of notes; track note) {
<un-note [note]="note"></un-note>
} @if (notes?.length) {
<div class="load">
  @if (totalPages > 1 && limit !== totalPages) {
  <a class="c-secondary t-center" (click)="loadMore()" i18n
    >Load more <un-icon type="down" theme="outline"></un-icon
  ></a>
  }
</div>
} @else {
<un-empty
  class="un-card"
  icon="transactions"
  [size]="200"
  description="You have no notes yet."
  i18n-description="@@youHaveNoNotesYet"
></un-empty>
}
<footer class="footer p-t-16">
  <un-button class="m-l-a" type="primary" i18n (click)="createNote()">
    <fa-icon [icon]="faPlusCircle"></fa-icon>
    Add Note
  </un-button>
</footer>
